// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610142305/js/" + chunkId + "." + {"44":"5ae01c8c","225":"1d76003e","481":"7e419f95","486":"7e7690e0","770":"fd2467b0"}[chunkId] + ".0.9555379160168471.chunk.js";
};